<template>
  <div class="widget-renderer">
    <!-- Metric Widget -->
    <MetricWidget
      v-if="widget.type === 'metric'"
      :widget="widget"
      @update="$emit('update', $event)"
    />
    
    <!-- Chart Widget -->
    <ChartWidget
      v-else-if="widget.type === 'chart'"
      :widget="widget"
      @update="$emit('update', $event)"
    />
    
    <!-- Table Widget -->
    <TableWidget
      v-else-if="widget.type === 'table'"
      :widget="widget"
      @update="$emit('update', $event)"
    />
    
    <!-- KPI Widget -->
    <KpiWidget
      v-else-if="widget.type === 'kpi'"
      :widget="widget"
      @update="$emit('update', $event)"
    />
    
    <!-- Unknown Widget Type -->
    <div v-else class="unknown-widget">
      <v-icon size="48" color="grey lighten-2">mdi-help-circle-outline</v-icon>
      <p class="text-body-2 grey--text mt-2">Unknown widget type: {{ widget.type }}</p>
    </div>
  </div>
</template>

<script>
import MetricWidget from './widgets/MetricWidget.vue'
import ChartWidget from './widgets/ChartWidget.vue'
import TableWidget from './widgets/TableWidget.vue'
import KpiWidget from './widgets/KpiWidget.vue'

export default {
  name: 'WidgetRenderer',
  components: {
    MetricWidget,
    ChartWidget,
    TableWidget,
    KpiWidget
  },
  props: {
    widget: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.widget-renderer {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.unknown-widget {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  flex: 1;
}
</style> 